<style lang="scss" scoped>

#login-logo {
    height: auto;
    max-width: 100%;
    max-height: 38px;
}

</style>

<template>
    <header class="navbar navbar-expand-md navbar-light d-print-none">
        <div class="container-xl">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" >
                <span class="navbar-toggler-icon">
                </span>
            </button>
            <h1 class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3" style="height:44px">
                <router-link to="/" class="text-decoration-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon text-green" width="24" height="24" viewBox="3 4 18 18" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <rect x="10" y="5" width="10" height="14" rx="2" />
                          <line x1="7" y1="7" x2="7" y2="17" />
                          <line x1="4" y1="8" x2="4" y2="16" />
                    </svg>
                    <span class="ps-1">Bewässerungs-App Mobil</span>
                </router-link>
            </h1>
            <div class="navbar-nav flex-row order-md-last">
                <template v-if="false">
                <div class="nav-item dropdown d-md-flex me-2">
                    <a href="#" class="nav-link px-0" data-bs-toggle="dropdown" tabindex="-1" aria-label="Show notifications">
                    <!-- Download SVG icon from http://tabler-icons.io/i/bell -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg>
                    <span class="badge bg-red"></span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-card">
                        <div class="card">
                            <div class="card-body">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus ad amet consectetur
                                exercitationem fugiat in ipsa ipsum, natus odio quidem quod repudiandae sapiente.
                                Amet debitis et magni maxime necessitatibus ullam.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown"
                    aria-label="Open user menu">
                    <span class="avatar avatar-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user" width="56" height="56" viewBox="4 2 15 15" stroke-width="2" stroke="#9e9e9e" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <circle cx="12" cy="7" r="4" />
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                        </svg>
                    </span>
                   
                   <div class="d-none d-sm-block ps-2">
                        <div>Martin Müller</div>
                        <div class="mt-1 small text-muted">Landwirt</div>
                    </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <div class="px-3 pt-1">Martin Müller</div>
                        <div class="px-3 pt-0 pb-1 small text-muted">Landwirt</div>
                        <div class="dropdown-divider"></div>
                        <a href="#" class="dropdown-item" @click="logOut">Abmelden</a>
                    </div>
                </div>
                </template>
                <div class="nav-item dropdown">
                    <div style="width:100%;">
                        <img id="login-logo" src="@/assets/logo.png" alt="ALB Bayern e.V."> 
                    </div>
                </div>
            </div>
        </div>
    </header>
    <div class="navbar-expand-md">
        <div class="collapse navbar-collapse" id="navbar-menu" ref="menu">
            <div class="navbar navbar-light">
                <div class="container-xl">
                    <ul class="navbar-nav">
                        <router-link to="/" custom  v-slot="{ href, navigate, isActive }">        
                        <li class="nav-item" :class="{ active: isActive }">
                                <a class="nav-link" :href="href" @click="[navigate($event), hideMenu($event)]">     
                                <span class="nav-link-icon d-lg-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                                    <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                                    <path d="M9 17v-4" />
                                    <path d="M12 17v-1" />
                                    <path d="M15 17v-2" />
                                    <path d="M12 17v-1" />
                                </svg>
                                </span>
                                <span class="nav-link-title">
                                    Erfassen
                                </span>
                                </a>
                        </li>
                        </router-link>
                        <router-link to="/profiles" custom  v-slot="{ href, navigate, isActive }">        
                        <li class="nav-item" :class="{ active: isActive }">
                                <a class="nav-link"  :href="href" @click="[navigate($event), hideMenu($event)]" >
                                <span class="nav-link-icon d-lg-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="3 3 20 20" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M8 5v10a1 1 0 0 0 1 1h10" />
                                    <path d="M5 8h10a1 1 0 0 1 1 1v10" />
                                </svg>
                                </span>
                                <span class="nav-link-title">
                                    Schläge
                                </span>
                                </a>
                        </li>
                        </router-link>
                        <router-link to="/waterpoints" custom  v-slot="{ href, navigate, isActive }">        
                        <li class="nav-item" :class="{ active: isActive }">
                                <a class="nav-link"  :href="href" @click="[navigate($event), hideMenu($event)]">
                                <span class="nav-link-icon d-lg-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" data-v-4f46756f=""></path>
                                    <path d="M3 7c3 -2 6 -2 9 0s6 2 9 0" data-v-4f46756f=""></path>
                                    <path d="M3 17c3 -2 6 -2 9 0s6 2 9 0" data-v-4f46756f=""></path>
                                    <path d="M3 12c3 -2 6 -2 9 0s6 2 9 0" data-v-4f46756f=""></path>
                                </svg>
                                </span>
                                <span class="nav-link-title">
                                    Entnahmestellen
                                </span>
                                </a>
                        </li>
                        </router-link>
                        <router-link to="/sensors" custom  v-slot="{ href, navigate, isActive }">        
                        <li class="nav-item" :class="{ active: isActive }">
                                <a class="nav-link"  :href="href" @click="[navigate($event), hideMenu($event)]">
                                <span class="nav-link-icon d-lg-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                </svg>
                                </span>
                                <span class="nav-link-title">
                                    Sensorik
                                </span>
                                </a>
                        </li>
                        </router-link>
                        <router-link to="/info" custom  v-slot="{ href, navigate, isActive }">        
                        <li class="nav-item" :class="{ active: isActive }">
                            <a class="nav-link" :href="href" @click="[navigate($event), hideMenu($event)]">
                            <span class="nav-link-icon d-lg-inline-block">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /><line x1="9" y1="9" x2="10" y2="9" /><line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="15" y2="17" /></svg>
                            </span>
                            <span class="nav-link-title">
                                Allgemeine Hinweise
                            </span>
                            </a>
                        </li>
                        </router-link>
                        <li class="nav-item">
                            <a class="nav-link" href="#" @click="logOut">
                            <span class="nav-link-icon d-lg-inline-block">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 3v4a1 1 0 0 0 1 1h4" />
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                                <path d="M7 12h14l-3 -3m0 6l3 -3" />
                            </svg>
                            </span>
                            <span class="nav-link-title">
                                Abmelden <span v-show="userId"> von {{ userId }}</span>
                            </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

export default{
    name: 'Header',
    inject: [
        'state',
        'config'
    ],
    data: function () {
        return {
            userId: null
        }
    },
    computed: {},
    methods: {
        logOut: function () {
            this.$router.replace('/');
            this.state.actions.logOut();
        },
        hideMenu: function () {
            let self = this;
            self.bootstrap(function (bootstrap) {
                bootstrap.Collapse.getOrCreateInstance(self.$refs.menu).hide();
            });
        },
        showMenu: function () {
            let self = this;
            self.bootstrap(function (bootstrap) {
                bootstrap.Collapse.getOrCreateInstance(self.$refs.menu).show();
            });
        },
        bootstrap: function (callback) {
            let waitFor = setInterval(function () {
                if (window.bootstrap) {
                    clearInterval(waitFor);
                    callback(window.bootstrap);
                }
            }, 100);
        },
        fetchUser: function(callback) {
            
            if (!this.state.user.token) {
                this.userId = null;
                return;
            }
                
            let self = this;
            
            let query = {
                query: `
                    query {
                        user {
                            id
                            loggedIn
                        }
                    }
                `,      
                variables: {
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    //alert(JSON.stringify(data));
                    self.userId = data.user.id;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        
        },
    },
    watch: {
        'state.user.token' : function (new_value) {
            this.fetchUser();
        }
    },
    mounted: function () {
        this.fetchUser();
    }
}




</script>
